module.exports = __webpack_public_path__ + "img/bg4.7ce91842.png";